import RealTimeChart from './realTimeChart';
export default RealTimeChart;